import { createSelector } from 'reselect';
import qs from 'query-string';
import { PREFERENCE_SUBJECTS } from '../constants/preferences';
import { buildParams } from '../modules/preferences/utilities';

const getPreferences = state => state.preferences;
export const getPreference = preference => state => state.preferences[preference];

export const hasAdults = createSelector(
  getPreference(PREFERENCE_SUBJECTS),
  subjects => Object.entries(subjects).filter(([, value]) => value > 0).some(([subject]) => [9, 10].includes(parseInt(subject, 10)))
);

export const getQueryString = createSelector(
  getPreferences,
  preferences => qs.stringify(buildParams(preferences), { arrayFormat: 'bracket' })
);

export const getInitialPropertyPreferences = createSelector(
  getPreference('properties'),
  properties => properties.reduce((acc, property) => ({
    ...acc,
    [`preference-property-${property}`]: true
  }), {})
);

/**
 * We need to remove focus params that are null or which have an empty array is value
 * to avoid overwriting the state preferences
 */
const clearEmptyFocus = focus => Object.keys(focus).reduce((clearedFocus, key) => {
  if (!focus[key]) return clearedFocus;
  if (Array.isArray(focus[key]) && focus[key].length < 1) return clearedFocus;
  clearedFocus[key] = focus[key];
  return clearedFocus;
}, {});

export const getParams = focus => createSelector(
  getPreferences,
  preferences => ({
    ...preferences,
    ...clearEmptyFocus(focus),
  })
);
